import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { documentToReactComponents, } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import React from 'react';
export const defaultRichTextOptions = {
    renderMark: {
        [MARKS.BOLD]: (text) => {
            return _jsx("b", { children: text });
        },
    },
    renderNode: {
        [BLOCKS.HEADING_1]: (node, children) => !!children ? (_jsx(Typography.Title, { level: 1, elementTheme: "h1", noMargin: true, children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.HEADING_2]: (node, children) => !!children ? (_jsx(Typography.Title, { level: 2, elementTheme: "h2", noMargin: true, children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.HEADING_3]: (node, children) => !!children ? (_jsx(Typography.Title, { level: 3, elementTheme: "h3", noMargin: true, children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.HEADING_4]: (node, children) => !!children ? (_jsx(Typography.Title, { level: 4, elementTheme: "h4", noMargin: true, children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.HEADING_5]: (node, children) => !!children ? (_jsx(Typography.Title, { level: 5, elementTheme: "h5", noMargin: true, children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.HEADING_6]: (node, children) => !!children ? (_jsx(Typography, { elementTheme: "h6", children: children })) : (_jsx(_Fragment, {})),
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return _jsx(Typography, { children: children });
        },
    },
};
export const renderRichText = (document, options = defaultRichTextOptions) => {
    return _jsx(_Fragment, { children: documentToReactComponents(document, options) });
};
export const useRichText = (document, customOptions) => {
    const options = React.useMemo(() => (Object.assign(Object.assign(Object.assign({}, defaultRichTextOptions), customOptions), { renderMark: Object.assign(Object.assign({}, defaultRichTextOptions.renderMark), customOptions === null || customOptions === void 0 ? void 0 : customOptions.renderMark), renderNode: Object.assign(Object.assign({}, defaultRichTextOptions.renderNode), customOptions === null || customOptions === void 0 ? void 0 : customOptions.renderNode) })), [customOptions]);
    return React.useMemo(() => (document ? renderRichText(document, options) : null), [document, options]);
};
